// Phase 10 — Reading List module hook.

import { useQuery } from '@tanstack/react-query';

interface ReadingItem {
  id: string;
  title: string;
  author: string;
  status: string;
  rating: number | null;
  notes: string;
  created_at: string;
  updated_at: string;
}

export function useReadingList() {
  return useQuery<ReadingItem[]>({
    queryKey: ['reading', 'items'],
    queryFn: async () => {
      const res = await fetch('/api/modules/reading/items', {
        credentials: 'same-origin',
      });
      if (!res.ok) throw new Error('Failed to load reading list');
      return res.json();
    },
    staleTime: 30_000,
  });
}
